import { apiClient } from "../apiClient";
import { AxiosError } from "axios";
import { API_ENDPOINTS } from "@repo/constants";

const imageBaseUrl: string =
  "https://imagedelivery.net/Ud25niyQxx-TAH-Uqr9bjQ/";

export const imageThumb = (photoUrl: string): string => {
  return `${imageBaseUrl}${photoUrl}/thumb`;
};

export const imageOriginal = (photoUrl: string): string => {
  return `${imageBaseUrl}${photoUrl}/original`;
};

export const imageL = (photoUrl: string): string => {
  return `${imageBaseUrl}${photoUrl}/l`;
};

export const imageM = (photoUrl: string): string => {
  return `${imageBaseUrl}${photoUrl}/m`;
};

/**
 * Upload an image file and return the image URL/ID from the server.
 */
export const getUploadImageUrl = async (
  file: File,
): Promise<{ success: boolean; data: { id: string; url: string } }> => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post<{
      success: boolean;
      data: { id: string; url: string };
    }>(API_ENDPOINTS.uploadImage, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error("Error uploading image:", error);
    return { success: false, data: { id: "", url: "" } };
  }
};


